<template>
  <main class="page-operative page-operative-project page-operative-project-library-template page-operative-project-library-template-edit">
    <div class="container">
      <PageTitle>Modifica modello di progetto (libreria)</PageTitle>

      <div v-if="loading">LOADING ...</div>
      <div v-else-if="errorLoadingData">Modello di progetto (libreria) da modificare non trovato</div>
      <FormProjectLibraryTemplate v-else-if="company && userCanEdit" :template.sync="template" :libraryCosts="libraryCosts" :libraryImputedCosts="libraryImputedCosts" :personnel="personnel" edit @saved="saveTemplate" />
      <div v-else-if="company">Utente non abilitato</div>
    </div>
  </main>
</template>

<script>

import operativePageMixin from '@/mixins/operativePage';

export default {
  name: 'page-operative-company-project-library-template-edit',
  mixins: [operativePageMixin],
  components: {
    PageTitle: () => import('@/views/components/Layout/LayoutOperative/PageTitle'),
    FormProjectLibraryTemplate: () => import('@/views/components/Operative/Form/FormProjectLibraryTemplate'),
  },
  data () {
    return {
      template: null,
      loading: true,
      errorLoadingData: false,
      libraryCosts: [],
      libraryImputedCosts: [],
      personnel: [],
    };
  },
  methods: {
    saveTemplate (template) {
      this.$api.updateProjectLibraryTemplate(this.company.id, template.id, template)
        .then(() => {
          this.$router.push({
            name: 'operative-company.projects.library.templates.list',
            query: {
              forecast: this.$route.query?.forecast || null,
            },
          });
        })
        .catch(this.$log.error)
      ;
    },
  },
  mounted () {
    this.loading = true;
  },
  watch: {
    company: {
      immediate: true,
      handler: function () {
        if (!this.company) {
          return;
        }

        this.$api.listProjectLibraryCosts(this.company.id)
          .then(res => {
            this.libraryCosts = res.data?.costs || [];
          })
          .catch(this.$log.error)
        ;

        this.$api.listImputedCosts(this.company.id)
          .then(res => {
            this.libraryImputedCosts = res.data?.costs || [];
          })
          .catch(this.$log.error)
        ;

        this.$api.getCostiPersonale(this.company.id)
          .then(res => {
            this.personnel = res.data?.costi || [];
          })
          .catch(this.$log.error)
        ;

        this.$api.getProjectLibraryTemplate(this.company.id, this.$route.params.projectLibraryTemplateId)
          .then(res => {
            this.template = res.data;
          })
          .catch(err => {
            this.errorLoadingData = true;
            this.$log.error(err);
          })
          .finally(() => {
            this.loading = false;
          })
        ;
      },
    },
  },
};

</script>
